import { toast } from 'sonner';
import { SnackbarNotification } from '../../model/notification.types';

export const useNotification = () => {
    const addNotification = (notification: SnackbarNotification) => {
        const { message, type } = notification;

        switch (type) {
            case 'success':
                toast.success(message);
                break;
            case 'error':
                toast.error(message);
                break;
            case 'warning':
                toast.warning(message);
                break;
            default:
                toast(message);
        }
    };

    const clearNotifications = () => {
        toast.dismiss();
    };

    return {
        addNotification,
        clearNotifications,
    };
};
